/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-04 17:12:20
 * @LastEditors: yaozuo
 * @LastEditTime: 2026-01-28 10:12:03
 */
// eslint-disable-next-line @typescript-eslint/no-var-requires
const qiniu = require('qiniu-js')
import { service, javaService } from '@/common/utils/request'


/**
 * 获取七牛云token
 * @returns
 */
export function getQiniuToken() {
  return javaService.get('/kigo-game-server/home/qiniu/token')
}
/**
 * 直接上传七牛
 * @param data
 * @returns
 */
export function uploadImage2(data: File) {
  return new Promise((resolve, reject) => {
    getQiniuToken().then(res => {
      const token = res.data
      const key = new Date().getTime() + Math.floor(Math.random() * 10000)
      const putExtra = {}
      console.log('qiniu', qiniu)
      const config = {
        useCdnDomain: true,
        bucket: 'kigo'
        //region: qiniu.region.z2
      }
      const observable = qiniu.upload(data, key, token, putExtra, config)
      observable.subscribe({
        complete(res: any) {
          const url = `https://qiniu.wlwyl.com/${res.key}`
          resolve(url)
        },
        error(err: any) {
          reject(err)
        }
      })
    })
  })
}

/**
 * 根据类型获取微信js签名
 * @param params
 * @returns
 */
export function apiGetWxSign(params: any) {
  return javaService.get('/kigo-user-api/wechat/getSignInfoByType', { params })
}

/**
 * 百度回传数据
 * @param params 
 * @returns 
 */
export function apiAddBaiduAdMatch(data: any) {
  return javaService.post('/kigo-user-api/login/addBaiduAdMatch', data)
}